export const FIND_PRODUCT_BY_ID_REQUEST = "FIND_PRODUCT_BY_ID_REQUEST";
export const FIND_PRODUCT_BY_ID_SUCCESS = "FIND_PRODUCT_BY_ID_SUCCESS";
export const FIND_PRODUCT_BY_ID_FAILURE = "FIND_PRODUCT_BY_ID_FAILURE";
export const FIND_PRODUCT_REQUEST = "FIND_PRODUCT_REQUEST";
export const FIND_PRODUCT_SUCCESS = "FIND_PRODUCT_SUCCESS";
export const FIND_PRODUCT_FAILURE = "FIND_PRODUCT_FAILURE";
